import React, { Component } from 'react'
import { Button, Icon, Modal, PrimaryButton, Spinner, SpinnerSize } from '@fluentui/react'
import PropTypes from 'prop-types'
import './index.scss'
import LoadingGif from '../LoadingGif'

class ModalComponent extends Component {
  closeModal = () => {
    this.props.closeModalEvent()
  }

  executeNextStep = () => {
    this.props.nextModalEvent()
  }

  render() {
    const {
      isLoading = false,
      open,
      content,
      headerTitle,
      nextText,
      closeText,
      nextDisabled,
      modalClass,
      actionButtons,
      extraActionButtons,
      RenderExtraButton,
      showCloseButton,
      height,
      removeBackground,
    } = this.props

    return (
      <Modal
        isOpen={open}
        overlay={{
          className: removeBackground ? 'remove-background' : '',
        }}
        containerClassName={`modal-container ${modalClass}`}
        layerProps={{ eventBubblingEnabled: true }}
      >
        <div
          data-cy="modal_component"
          className="modal-wrapper"
          style={
            height ? { minHeight: height, maxHeight: height } : {}
          }
        >
          <div className="header-container">
            <div className="title">
              <h3>{headerTitle}</h3>
            </div>
            <div className="close-container">
              <Icon onClick={this.closeModal} iconName="Cancel" />
            </div>
          </div>
          {isLoading ? <LoadingGif /> : content}
          {actionButtons && (
            <div className="footer-container">
              {extraActionButtons && RenderExtraButton}
              {showCloseButton && (
                <Button
                  onClick={this.closeModal}
                  className="cancel-button"
                  style={{ fontSize: 14 }}
                >
                  {closeText}
                </Button>
              )}
              <PrimaryButton
                onClick={this.executeNextStep}
                disabled={nextDisabled || isLoading}
                className="primary-button"
              >
                {isLoading ? (
                  <Spinner size={SpinnerSize.xSmall} />
                ) : (
                  nextText
                )}
              </PrimaryButton>
            </div>
          )}
        </div>
      </Modal>
    )
  }
}

ModalComponent.propTypes = {
  open: PropTypes.bool.isRequired,
  content: PropTypes.oneOfType([PropTypes.object, PropTypes.bool])
    .isRequired,
  headerTitle: PropTypes.string.isRequired,
  actionButtons: PropTypes.bool,
  closeText: PropTypes.string,
  closeModalEvent: PropTypes.func,
  showCloseButton: PropTypes.bool,
  nextText: PropTypes.string,
  nextModalEvent: PropTypes.func,
  nextDisabled: PropTypes.bool,
  modalClass: PropTypes.string,
  isModalClose: PropTypes.bool,
  extraActionButtons: PropTypes.bool,
  RenderExtraButton: PropTypes.object,
  height: PropTypes.number,
}

ModalComponent.defaultProps = {
  height: 0,
  modalClass: '',
  closeText: '',
  closeModalEvent: () => {},
  nextModalEvent: () => {},
  nextText: '',
  nextDisabled: true,
  isModalClose: true,
  showCloseButton: true,
  actionButtons: true,
  extraActionButtons: false,
  RenderExtraButton: {},
}

export default ModalComponent
